// utils/groupMessages.js
export const groupMessages = (messages, currentUserId) => {
  const groups = {};

  messages.forEach((msg) => {
    const key = `${msg.ProdMessage || "noProd"}-${msg.subject}`;
    const groupId = msg.group_id;
    const senderGroupId = msg.sender_group_id;
    const receiverGroupId = msg.receiver_group_id;
    const isSender = msg.sender === currentUserId;
    const userGroupId = isSender ? senderGroupId : receiverGroupId;


    if (!groups[key]) {
      groups[key] = {
        subject: msg.subject,
        prodId: msg.ProdMessage || null,
        product_image: msg.product_image || null,
        rootId: msg.parent || msg.id,
        id: msg.id,
        group_id: groupId,
        sender_group_id: senderGroupId,
        receiver_group_id: receiverGroupId,
        messages: [],
        status: isSender ? msg.senders_status : msg.receivers_status,
        senders_status: msg.senders_status || "active",
        receivers_status: msg.receivers_status || "active",
        senders_seen: msg.senders_seen,
        receivers_seen: msg.receivers_seen,
        user_group_id: userGroupId || null,   
        hasUnseen: (msg.sender === currentUserId && msg.senders_seen === "unseen") ||
            (msg.receiver === currentUserId && msg.receivers_seen === "unseen"),
        isSender, 
      };
    }

    groups[key].messages.push(msg);

    if (!groups[key].product_image && msg.product_image) {
      groups[key].product_image = msg.product_image;
    }


  });

  return groups;
};
